module.exports = __webpack_public_path__ + "static/media/success.cda40574.svg";